import { render, staticRenderFns } from "./side-bar.vue?vue&type=template&id=63fc613b"
import script from "./side-bar.vue?vue&type=script&lang=js"
export * from "./side-bar.vue?vue&type=script&lang=js"
import style0 from "./side-bar.vue?vue&type=style&index=0&id=63fc613b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports